import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { ApplicationArtatech } from './application-artatech.model';
import { ApplicationArtatechService } from './application-artatech.service';

@Component({
    selector: 'dcs-application-artatech-detail',
    templateUrl: './application-artatech-detail.component.html'
})
export class ApplicationArtatechDetailComponent implements OnInit, OnDestroy {

    application: ApplicationArtatech;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private applicationService: ApplicationArtatechService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['application']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.applicationService.find(id).subscribe(application => {
            this.application = application;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech-detail.component.ts